<div class="flex gap-2">
  <app-pan-button color="info" icon="edit" (click)="params.editCallback(params.data)" matTooltip="Edit Location"></app-pan-button>

  <app-pan-button
    fill="outline"
    [icon]="(params.data.flagged_reasons ?? []).length === 0 ? 'flag' : 'counter_' + params.data.flagged_reasons.length"
    (click)="flagModal.show()"
    [color]="(params.data.flagged_reasons ?? []).length > 0 ? 'danger' : 'default'"
    [matTooltip]="(params.data.flagged_reasons ?? []).length > 0 ? params.data.flagged_reasons.length + ' Flag(s)' : ''"
  ></app-pan-button>

  <app-pan-button fill="outline" color="info" [matMenuTriggerFor]="menu" icon="more_vert" panRole [roles]="['admin']">
    <mat-menu #menu="matMenu">
      <a mat-menu-item (click)="params.mergeCallback(params.data)">
        <span>Merge</span>
      </a>

      <a mat-menu-item [swal]="archiveSwal">
        <span>Archive</span>
      </a>

      <a mat-menu-item (click)="params.transferCallback(params.data)">
        <span>Transfer</span>
      </a>
    </mat-menu>
  </app-pan-button>
</div>

<swal
  #archiveSwal
  title="Archive Location?"
  text="Are you sure you want to archive this location?"
  icon="warning"
  confirmButtonText="Yes, Archive"
  [showCancelButton]="true"
  [focusCancel]="true"
  (confirm)="params.archiveCallback(params.data)"
>
</swal>

<app-pan-modal #flagModal (modalWillOpen)="updateCodes()">
  <div header>Flags for {{ params.data.name }}</div>

  <div body class="flex flex-col gap-2">
    @for (code of errorReasonCodes; track $index) {
      <div>
        <label>
          <input
            type="checkbox"
            panCheckbox
            (change)="updateSelection(code.id, $event.target)"
            [checked]="(params.data.flagged_reasons ?? []).includes(code.id)"
          />
          {{ code.description }}
        </label>
      </div>
    }
  </div>

  <div footer class="flex items-end gap-2">
    <button panButton panModalClose>Cancel</button>
    <button panButton panModalClose (click)="saveErrorFlags()" color="primary">Save</button>
  </div>
</app-pan-modal>
